import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FormatType, formatTypes, IAddImage, WhiteboardElement } from './models';

type ForeignData = {
  [_: string]: {
    visible: boolean;
    data: WhiteboardElement[];
  };
};

@Injectable({
  providedIn: 'root',
})
export class NgWhiteboardService {
  // Observable string sources
  private eraseMethodCallSource = new Subject<void>();
  private saveMethodCallSource = new Subject<{
    name: string;
    format: formatTypes;
  }>();
  private undoMethodCallSource = new Subject<void>();
  private redoMethodCallSource = new Subject<void>();
  private addImageMethodCallSource = new Subject<IAddImage>();

  // Observable string streams
  eraseMethodCalled$ = this.eraseMethodCallSource.asObservable();
  saveMethodCalled$ = this.saveMethodCallSource.asObservable();
  undoMethodCalled$ = this.undoMethodCallSource.asObservable();
  redoMethodCalled$ = this.redoMethodCallSource.asObservable();
  addImageMethodCalled$ = this.addImageMethodCallSource.asObservable();

  public data: BehaviorSubject<WhiteboardElement[]> = new BehaviorSubject<WhiteboardElement[]>([]);
  public foreignData: BehaviorSubject<ForeignData> = new BehaviorSubject<ForeignData>({});
  public undoStack = new BehaviorSubject<WhiteboardElement[][]>([]);
  public redoStack = new BehaviorSubject<WhiteboardElement[][]>([]);

  // Service message commands
  public erase(): void {
    this.eraseMethodCallSource.next();
  }
  public save(format: formatTypes = FormatType.Base64, name = 'New board'): void {
    this.saveMethodCallSource.next({ name, format });
  }
  public undo(): void {
    this.undoMethodCallSource.next();
  }
  public redo(): void {
    this.redoMethodCallSource.next();
  }
  public addImage(image: string | ArrayBuffer, x?: number, y?: number): void {
    this.addImageMethodCallSource.next({ image, x, y });
  }
}
